import { Access } from "@p0security/shared/types/access/index";

export const AwsOidcAccesses = {
  identity: Access({
    description: "Access AWS via a federated OIDC provider",
    label: "AWS IAM access",
    maturity: "preview",
    delegation: {},
    generated: {
      arn: { type: "string", label: "ARN of OIDC role" },
      name: { type: "string", label: "Name of OIDC role" },
      policyArn: { type: "string", label: "Generated policy ARN" },
      policyDocument: {
        type: "string",
        label: "Policy JSON",
        description:
          "The policy JSON in the generated policy that grants conditional access based on the identity",
      },
      policyName: { type: "string", label: "Generated policy name" },
    },
    parameters: {
      accountId: {
        type: "generated",
        label: "Account ID",
        description: "AWS's internal numeric ID for this account",
      } as const,
      policyDraft: {
        type: "input",
        optional: true,
        label: "Policy draft",
        description:
          "Unhydrated policy document JSON generated at request time",
      } as const,
    },
    render: { locator: "accountId" } as const,
  }),
};

export type AwsOidcAccesses = typeof AwsOidcAccesses;
